module.exports = {
	"layoutContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/layout-index.json
// module chunks = 3954140758598355500 7489246917808536000